import React, {
  ReactElement,
  Fragment,
} from 'react';
import {IconButton, MenuItem, Stack} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Popover from '@mui/material/Popover';
import {
  CancelRounded,
  FileUploadRounded,
  TextsmsRounded
} from "@mui/icons-material";
import {useStateContext} from "../../../hooks/useStateContext";

export const MoreOptions = ({
                              clickOnReject,
                              past,
                              clickOnOpenChat,
                              clickOnOpenFileUpload,
                              isRejected,
                            }: {
  clickOnReject: () => void;
  clickOnOpenChat: () => void;
  clickOnOpenFileUpload: () => void;
  isRejected: boolean;
  past?: any;
}): ReactElement => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );
  const {user} = useStateContext();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <>
      <IconButton
        size={'small'}
        aria-label="more options"
        color={'default'}
        onClick={handleClick}
      >
        <MoreVertIcon/>
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        onClick={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        {(!isRejected && past!==1) && (
          <MenuItem
            onClick={() => {
              clickOnReject();
            }}
          >
            <Stack direction={'row'} gap={1}>
              <CancelRounded color={'error'}/> <span>Foglalás elutasítása</span>
            </Stack>
          </MenuItem>
        )}
        <MenuItem
          onClick={() => {
           clickOnOpenChat();
          }}
        >
          <Stack direction={'row'} gap={1}>
            <TextsmsRounded color={'primary'}/> <span>Chat megnyitása</span>
          </Stack>
        </MenuItem>
        <MenuItem
          onClick={() => {
           clickOnOpenFileUpload();
          }}
        >
          <Stack direction={'row'} gap={1}>
            <FileUploadRounded color={'primary'}/> <span>Fájl feltöltése</span>
          </Stack>
        </MenuItem>

      </Popover>
    </>
  );
};
